document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector('[data-infinite-scroll]');
  if (!grid) return; // Exit if infinite scroll isn't enabled

  const pagination = document.getElementById('pagination');
  const loader = document.getElementById('infinite-loader');
  if (!pagination) return;

  let nextPageLink = pagination.querySelector('.pagination__next')?.getAttribute('href');
  let isLoading = false;

  const loadMore = () => {
    if (!nextPageLink || isLoading) return;
    isLoading = true;

    pagination.style.display = 'none';
    if (loader) loader.style.display = 'block';

    fetch(nextPageLink)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newItems = doc.querySelector('[data-infinite-scroll]').innerHTML;
        const newPagination = doc.getElementById('pagination');

        grid.insertAdjacentHTML('beforeend', newItems);

        if (newPagination) {
          const newNextLink = newPagination.querySelector('.pagination__next')?.getAttribute('href');
          nextPageLink = newNextLink;

          if (!newNextLink && loader) loader.remove();
        } else {
          if (loader) loader.remove();
        }

        isLoading = false;
      })
      .catch(() => {
        isLoading = false;
        if (loader) loader.innerText = 'Something went wrong. Please try again.';
      });
  };

  window.addEventListener('scroll', () => {
    const scrollThreshold = 300;
    const scrollPosition = window.scrollY + window.innerHeight;
    const bottom = document.documentElement.scrollHeight - scrollThreshold;

    if (scrollPosition > bottom) {
      loadMore();
    }
  });
});
